/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Nav_QuestsInputs */

const en_control_nav_quests = /** @type {(inputs: Control_Nav_QuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quests`)
};

const zh_control_nav_quests = /** @type {(inputs: Control_Nav_QuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任务攻略`)
};

/**
* | output |
* | --- |
* | "Quests" |
*
* @param {Control_Nav_QuestsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_nav_quests = /** @type {((inputs?: Control_Nav_QuestsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Nav_QuestsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_nav_quests(inputs)
	return zh_control_nav_quests(inputs)
});
export { control_nav_quests as "control.nav.quests" }